import Vue from "vue";

Vue.directive("toggle-basket-preview",
    {
        bind(el)
        {
            el.addEventListener("click", event =>
            {
                document.body.classList.toggle("basket-open");
                document.querySelector(".mobile-navigation").classList.remove("open");
                document.querySelector("body").classList.remove("menu-is-visible");

                event.preventDefault();
                event.stopPropagation();
            });
        }
    });
